import { createContext } from "react";
export const RoutineContext = createContext(null)